// @flow

import * as React from "react";

import type { TaskType } from "../data/tasks";
import FermiInstructions from "./fermi/instructions";
import FermiTask from "./fermi/task";
import PolitifactInstructions from "./politifact/instructions";
import PolitifactTask from "./politifact/task";
import PapersInstructions from "./papers/instructions";
import PapersTask from "./papers/task";

export type Template = {
  instructions: () => React.Node,
  task: {
    prompt: string,
    confidenceLabels: {
      left: string,
      middle: string,
      right: string
    },
    answerText: {
      false: string,
      true: string
    },
    renderQuestion: (task: TaskType) => React.Node,
    tools: {
      scratchpad?: boolean,
      wikipedia?: boolean,
      google?: boolean,
      pdf?: boolean
    }
  },
  title: string,
  example: string,
  icon: string
};

const templates: { [string]: Template } = {
  fermi: {
    instructions: FermiInstructions,
    task: FermiTask,
    title: "Fermi arithmetic problems",
    example:
      "Is “the weight of an African elephant x 3” greater than 10300 kg?",
    icon: "/images/project-icons/fermi.jpg"
  },
  politifact: {
    instructions: PolitifactInstructions,
    task: PolitifactTask,
    title: "Fact-checking political statements",
    example:
      "In 2017, House Dems introduced a bill to remove citizenship requirement from presidency. Is this true or false?",
    icon: "/images/project-icons/politifact.png"
  },
  papers: {
    instructions: PapersInstructions,
    task: PapersTask,
    title: "ML paper preferences",
    example:
      "Look at a paper from a machine learning conference. Is it the kind of paper you’d like to read?",
    icon: "/images/project-icons/papers.png"
  }
};

export default templates;



// WEBPACK FOOTER //
// ./src/templates/index.js